import { formatChatMessageTime } from "hhn-commons";
import { MessageStatusProps } from "../RecipientMessageStatus";
import { MessageStatusBox, MessageStatusText } from "./MessageStatus.style";
import { CircularProgress } from "@mui/material";
import React from "react";
import SendingWithDots from "./SendingWithDots";

const MessagePendingStatus = ({ timestamp }: MessageStatusProps) => {
  return (
    <MessageStatusBox data-testid="message-pending-status">
      <CircularProgress size={16} />
      <MessageStatusText>
        <SendingWithDots />
      </MessageStatusText>
      {timestamp && formatChatMessageTime(timestamp)}
    </MessageStatusBox>
  );
};
export default MessagePendingStatus;
